import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import * as calendar from '../../../sdk/calendar';
import { Actions } from '../../actions';
import { GetAppointmentByDate, GetAppointmentByDateError, GetAppointmentByDateSuccess } from '../action-creators';
import { GET_APPOINTMENT_BY_DATE } from '../actions';
import { Appointment } from '../state';

export const listAppointmentEpic = (action$: Observable<Actions>): Observable<Actions> =>
  action$.pipe(
    ofType<Actions, GetAppointmentByDate['type'], GetAppointmentByDate>(GET_APPOINTMENT_BY_DATE),
    mergeMap(async (action) => {
      try {
        const result = await calendar.getAppointmentByDate(action.date);
        const filterOnlyAppointment = result.items.filter(({ type }) => type === 'SERVICE') as Appointment[];
        return new GetAppointmentByDateSuccess(filterOnlyAppointment);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (err: any) {
        return new GetAppointmentByDateError(err.message, err.description);
      }
    })
  );
